import { render, staticRenderFns } from "./ModalContentDeleteProject.vue?vue&type=template&id=fac9aaa8&scoped=true&"
import script from "./ModalContentDeleteProject.vue?vue&type=script&lang=js&"
export * from "./ModalContentDeleteProject.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentDeleteProject.vue?vue&type=style&index=0&id=fac9aaa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac9aaa8",
  null
  
)

export default component.exports